export default "__VITE_ASSET__CqElY92P__"